var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-opening-hours" }, [
    _c("header", { staticClass: "tls-simple-banner" }, [
      _c("div", { staticClass: "tls-home-text-group" }, [
        _c("h1", { staticClass: "tls-heading-1" }, [
          _vm._v(_vm._s(_vm._.get(_vm.openingHoursCmsData, "title")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tls-simple-text -color-white -size-20" })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tls-opening-hours-map" }, [
      _c("div", { staticClass: "tls-large-card-map" }, [
        _c("div", { staticClass: "tls-card-lg" }, [
          _c("div", { staticClass: "tls-large-card-body" }, [
            _c("div", { staticClass: "tls-large-card-map--description" }, [
              _c("div", { staticClass: "tls-address" }, [
                _c("div", { staticClass: "tls-address-icon" }, [
                  _c("img", {
                    staticClass: "tls-address-icon-img",
                    attrs: {
                      src:
                        _vm.MINIO_BUCKET_ADDRESS + "/return-to-the-centre.png"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tls-address-desc" }, [
                  _c("div", { staticClass: "tls-address-title" }, [
                    _c("h2", { staticClass: "tls-heading-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm._.get(_vm.openingHoursCmsData, "address_title")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-address-description-bold" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tls-simple-text -color-main -weight-bold -size-16"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._.get(
                              _vm.applicationCenterCmsData,
                              "address_name"
                            )
                          ) + "\n                                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-address-description-italic" }, [
                    _c("div", {
                      directives: [
                        {
                          name: "dompurify-html",
                          rawName: "v-dompurify-html",
                          value: _vm._.get(
                            _vm.applicationCenterCmsData,
                            "address"
                          ),
                          expression:
                            "_.get(applicationCenterCmsData, 'address')"
                        }
                      ],
                      staticClass:
                        "tls-simple-text -color-main -size-16 -style-italic"
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tls-large-card-map--map" }, [
              _c("div", { staticClass: "tls-google-map" }, [
                _vm._.get(_vm.applicationCenterCmsData, "address_google_map")
                  ? _c("iframe", {
                      staticClass: "tls-google-map-iframe",
                      attrs: {
                        src: _vm._.get(
                          _vm.applicationCenterCmsData,
                          "address_google_map"
                        )
                      }
                    })
                  : _vm._e()
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tls-static-content tls-opening-hours-content" },
      [
        !_vm._.isNil(_vm.vacAvsCmsData)
          ? _c("div", { staticClass: "tls-opening-hours-avs" }, [
              _c("div", { staticClass: "tls-opening-hours-avs--title" }, [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(
                        _vm.applicationCenterCmsData,
                        "passback_avs_title"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-opening-hours-avs--content" }, [
                _c("div", { staticClass: "tls-avs" }, [
                  _c("div", { staticClass: "tls-avs-icon-ribbon" }, [
                    _c("img", {
                      staticClass: "tls-avs-icon-img",
                      attrs: {
                        src: _vm.MINIO_BUCKET_ADDRESS + "/icon-ribbon.png"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-card-info" }, [
                    _c("div", { staticClass: "tls-card-info--content" }, [
                      _c(
                        "div",
                        { staticClass: "tls-card-info--content-paragraph" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "tls-simple-text -color-main -weight-bold -size-16"
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.applicationCenterCmsData,
                                      "opening_hours_avs.name"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tls-simple-text -size-16" },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.applicationCenterCmsData,
                                      "opening_hours_avs.short_description"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tls-card-info--content-price" },
                        [
                          _vm._.get(_vm.vacAvsCmsData, "currency.code")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "tls-simple-text -color-main -weight-bold -size-19"
                                },
                                [
                                  _vm._.get(_vm.vacAvsCmsData, "price") > 0 &&
                                  _vm._.get(
                                    _vm.vacAvsCmsData,
                                    "currency.code"
                                  ) !== _vm.onDemand
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                       " +
                                            _vm._s(
                                              _vm._.get(
                                                _vm.vacAvsCmsData,
                                                "currency.name"
                                              ) ||
                                                _vm._.get(
                                                  _vm.vacAvsCmsData,
                                                  "currency.code"
                                                )
                                            ) +
                                            "   " +
                                            _vm._s(
                                              _vm._.get(
                                                _vm.vacAvsCmsData,
                                                "price"
                                              ).toFixed(2)
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n                                       " +
                                            _vm._s(
                                              _vm._.get(
                                                _vm.onDemandCurrency,
                                                "name"
                                              )
                                                ? _vm._.get(
                                                    _vm.onDemandCurrency,
                                                    "name"
                                                  )
                                                : _vm.onDemand
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tls-card-info--content-button" },
                            [
                              _c("div", { staticClass: "tls-button-dynamic" }, [
                                _c(
                                  "div",
                                  { staticClass: "tls-button-dynamic--text" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "tls-simple-text -color-primary -size-19"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tls-simple-text -color-primary -size-19",
                                            on: {
                                              click: function($event) {
                                                _vm.moreAvsInfo(
                                                  _vm._.get(
                                                    _vm.applicationCenterCmsData,
                                                    "opening_hours_avs"
                                                  )
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._.get(
                                                    _vm.keywords,
                                                    "more_info"
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(1)
                              ])
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._.get(_vm.applicationCenterCmsData, "opening_hours.length") > 0
          ? _c("div", { staticClass: "tls-opening-hours-time" }, [
              _c("div", { staticClass: "tls-opening-hours-time--title" }, [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(_vm.openingHoursCmsData, "opening_hours_title")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-opening-hours-time--content" }, [
                _c("div", { staticClass: "tls-table" }, [
                  _c("div", { staticClass: "tls-card-lg" }, [
                    _c(
                      "table",
                      _vm._l(
                        _vm._.get(
                          _vm.applicationCenterCmsData,
                          "opening_hours"
                        ),
                        function(opening_hours_line) {
                          return _c("tr", [
                            _c("th", { staticClass: "tls-table-head" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(
                                    opening_hours_line,
                                    "opening_hours_service"
                                  )
                                ) + "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", {
                              directives: [
                                {
                                  name: "dompurify-html",
                                  rawName: "v-dompurify-html",
                                  value: _vm._.get(
                                    opening_hours_line,
                                    "opening_hours_duration"
                                  ),
                                  expression:
                                    "_.get(opening_hours_line, 'opening_hours_duration')"
                                }
                              ],
                              staticClass: "tls-table-cell"
                            })
                          ])
                        }
                      ),
                      0
                    )
                  ])
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._.get(_vm.applicationCenterCmsData, "closed_days.length") > 0
          ? _c("div", { staticClass: "tls-opening-hours-closed" }, [
              _c("div", { staticClass: "tls-opening-hours-closed--title" }, [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm._.get(_vm.openingHoursCmsData, "closed_days_title")
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-opening-hours-closed--content" }, [
                _c("div", { staticClass: "tls-table" }, [
                  _c("div", { staticClass: "tls-card-lg" }, [
                    _c(
                      "table",
                      _vm._l(
                        _vm._.get(_vm.applicationCenterCmsData, "closed_days"),
                        function(closed_days_line) {
                          return _c("tr", [
                            _c("th", { staticClass: "tls-table-head" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(
                                    closed_days_line,
                                    "closed_days_date"
                                  )
                                ) + "\n                                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "tls-table-cell" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._.get(
                                    closed_days_line,
                                    "closed_days_reason"
                                  )
                                ) + "\n                                "
                              )
                            ])
                          ])
                        }
                      ),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  directives: [
                    {
                      name: "dompurify-html",
                      rawName: "v-dompurify-html",
                      value: _vm._.get(
                        _vm.applicationCenterCmsData,
                        "holiday_notice"
                      ),
                      expression:
                        "_.get(applicationCenterCmsData, 'holiday_notice')"
                    }
                  ],
                  staticClass: "tls-opening-hours-holiday--notice"
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._.get(_vm.applicationCenterCmsData, "opening_days.length") > 0
          ? _c(
              "div",
              { staticClass: "tls-opening-days-time tls-opening-hours-time" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "tls-opening-days-time tls-opening-hours-time--title"
                  },
                  [
                    _c("h2", { staticClass: "tls-heading-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm._.get(
                            _vm.openingHoursCmsData,
                            "opening_days_title"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "tls-opening-days-time tls-opening-hours-time--content"
                  },
                  [
                    _c("div", { staticClass: "tls-table" }, [
                      _c("div", { staticClass: "tls-card-lg" }, [
                        _c(
                          "table",
                          _vm._l(
                            _vm._.get(
                              _vm.applicationCenterCmsData,
                              "opening_days"
                            ),
                            function(opening_hours_line) {
                              return _c("tr", [
                                _c("th", { staticClass: "tls-table-head" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._.get(
                                        opening_hours_line,
                                        "opening_days_service"
                                      )
                                    ) + "\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", {
                                  directives: [
                                    {
                                      name: "dompurify-html",
                                      rawName: "v-dompurify-html",
                                      value: _vm._.get(
                                        opening_hours_line,
                                        "opening_days_duration"
                                      ),
                                      expression:
                                        "_.get(opening_hours_line, 'opening_days_duration')"
                                    }
                                  ],
                                  staticClass: "tls-table-cell"
                                })
                              ])
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showPopup
          ? _c("popup", {
              attrs: {
                "popup-component-name": "simple-text",
                "popup-title": _vm._.get(_vm.moreAvsInfoData, "name"),
                "popup-data": {
                  simpleText: _vm._.get(
                    _vm.moreAvsInfoData,
                    "long_description"
                  ),
                  videoLink: _vm._.get(_vm.moreAvsInfoData, "video_url")
                },
                hasConfirmAction: false,
                hasCancelAction: false
              },
              on: { "close-action": _vm.closeAvsPopup }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-large-card-map--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-button-dynamic--decoration" }, [
      _c("div", { staticClass: "tls-line1" }),
      _vm._v(" "),
      _c("div", { staticClass: "tls-line2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }